import { Component, EventEmitter, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { SelectButtonModule } from 'primeng/selectbutton';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-ai-ask',
  imports: [FormsModule, SelectButtonModule, InputTextareaModule, ButtonModule, DropdownModule],
  templateUrl: './ai-ask.component.html',
  styleUrls: ['./ai-ask.component.scss'],
})
export class AiAskComponent {
  @Output() getUserInput = new EventEmitter<any>(false);
  userInput = '';
  dialogRef?: DynamicDialogRef;

  constructor(private dialogService: DialogService) {}

  submitUserInput() {
    this.getUserInput.emit(this.userInput);
    this.userInput = '';
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      if (event.shiftKey) {
        return; // Allow Shift + Enter for new lines
      } else {
        event.preventDefault(); // Prevent default behavior (e.g., form submission)
        this.submitUserInput();
      }
    }
  }
}
